export function MobileMenuFooter() {
  return (
    <div className="flex flex-col gap-3 h-full">
      <div className="h-full flex flex-col justify-end gap-3">
        <span className="tracking-[-0.04em] leading-[110%] text-brand-700 font-medium">
          Socijalne mreže
        </span>

        <div className="flex gap-6">
          <a
            className="hover:text-brand-700 transition-all duration-150 ease-in-out text-lg leading-[110%] tracking-[-0.04em] font-medium"
            href="https://www.instagram.com/dentivo.hr"
          >
            Instagram
          </a>
          <a
            className="hover:text-brand-700 transition-all duration-150 ease-in-out text-lg leading-[110%] tracking-[-0.04em] font-medium"
            href="https://www.facebook.com/dentivo.hr"
          >
            Facebook
          </a>
          <a
            className="hover:text-brand-700 transition-all duration-150 ease-in-out text-lg leading-[110%] tracking-[-0.04em] font-medium"
            href="https://www.linkedin.com/company/dentivo"
          >
            LinkedIn
          </a>
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <a
          href="tel:051276745"
          className="text-foreground/60 leading-[1.5em] tracking-[-0.01em] hover:text-foreground/80"
        >
          Broj mobitela: 051 276 745
        </a>
        <a
          href="mailto:info@dentivo.hr"
          className="text-foreground/60 leading-[1.5em] tracking-[-0.01em] hover:text-foreground/80"
        >
          Email: info@dentivo.hr
        </a>
      </div>
    </div>
  );
}
